
export default {
  sort: 7,
  path: '/reservationMainPage',
  name: 'mainPage',
  component: () => import('@/views/User/reservation/mainPage'),
}



// WEBPACK FOOTER //
// ./src/router/modules/reservation.js